module.exports = __webpack_public_path__ + "static/img/medical-patent.13fff2c2.png";